@if (collection) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <h2 class="visually-hidden">{{ "forms.collection.material.title" | translate }}</h2>
    <alert type="info" aria-hidden="true">
      <i class="fa fa-info-circle fa-fw"></i>
      {{ "forms.collection.material.helpText" | translate }}
    </alert>
    <div cdkDropList (cdkDropListDropped)="drop($event)" class="mb-4">
      @for (materialOrHeading of materialsAndHeadingsArray.controls; track materialOrHeading; let i = $index) {
        <div
          cdkDrag
          class="border-bottom py-4">
          <fieldset formArrayName="materialsAndHeadings">
            <ng-container [formGroupName]="i">
              @if (materialOrHeading.get('id')) {
                <div class="row justify-content-between">
                  <div class="col-auto">
                    <h3>
                      <i class="fa fa-bars fa-fw me-2" aria-hidden="true"></i>
                      <span class="me-2">{{ i + 1 }}</span>
                      {{ materials.get(materialOrHeading.get("id").value).name[lang] }}
                    </h3>
                  </div>
                  <div class="col-auto">
                    <button type="button" class="btn btn-sm btn-link" (click)="addHeading(i)">
                      {{ "forms.collection.material.addHeadingAndDescription.button" | translate }}
                    </button>
                    <app-tooltip-button
                      key="forms.collection.material.addHeadingAndDescription.tooltip"
                      variant="help"></app-tooltip-button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 col-md-2">
                    <img
                      [src]="materials.get(materialOrHeading.get('id').value).thumbnail"
                      class="img-fluid mb-3"
                      [alt]="'demo.educationalMaterial.cover.alt' | translate" />
                  </div>
                  <!--thumbnail-->
                  <div class="col-9 col-md-6">
                    @if (materials.get(materialOrHeading.get('id').value).description[lang]) {
                      <p>
                        {{ materials.get(materialOrHeading.get("id").value).description[lang] }}
                      </p>
                    }
                    <ul class="list-unstyled">
                      @for (author of materials.get(materialOrHeading.get('id').value).authors; track author) {
                        <li>
                          @if (author.author !== '') {
                            {{ author.author }}
                            @if (author.organization.value !== '') {
                              ({{ author.organization.value }})
                            }
                          }
                          @if (author.author === '') {
                            {{ author.organization.value }}
                          }
                        </li>
                      }
                    </ul>
                  </div>
                  <div class="col-12 col-md-4 text-md-end">
                    <button type="button" class="btn btn-link" (click)="removeFromCollection(i)">
                      <i class="fa fa-trash fa-fw text-dark" aria-hidden="true"></i>
                      {{ "forms.collection.material.removeFromCollection" | translate }}
                    </button>
                    <!--<div class="tags">
                    <button type="button" class="btn btn-light disabled">
                      meta
                    </button>
                  </div>&lt;!&ndash;@todo: replace with actual data&ndash;&gt;-->
                </div>
              </div>
              <div class="row justify-content-between">
                <div class="col-auto">
                  <span class="me-4">
                    <img
                    src="assets/img/icons/learning-resource-types/{{
                      materials.get(materialOrHeading.get('id').value).learningResourceTypes[0].key
                    }}.svg"
                      class="img-icon"
                      aria-hidden="true" />
                    {{ materials.get(materialOrHeading.get("id").value).learningResourceTypes[0].value }}
                  </span>
                  <strong>{{ materials.get(materialOrHeading.get("id").value).license.value }}</strong>
                </div>
                <div class="col-auto">
                  <time
                    [attr.datetime]="materials.get(materialOrHeading.get('id').value).publishedAt | date: 'yyyy-MM-dd'">
                    {{ materials.get(materialOrHeading.get("id").value).publishedAt | date: "d.M.yyyy" }}
                  </time>
                </div>
              </div>
            } @else {
              <h3>
                <i class="fa fa-bars fa-fw me-2" aria-hidden="true"></i>
                <span class="me-2">{{ i + 1 }}</span>
                {{ "forms.collection.material.headingAndDescription" | translate }}
              </h3>
              <div class="form-group">
                <label for="{{ 'heading-' + i }}">{{ "forms.collection.material.heading.label" | translate }}*</label>
                <input
                  type="text"
                  class="form-control"
                  id="{{ 'heading-' + i }}"
                  formControlName="heading"
                [ngClass]="{
                  'is-invalid':
                    materialOrHeading.get('heading').invalid &&
                    (materialOrHeading.get('heading').dirty || materialOrHeading.get('heading').touched || submitted)
                }" />
                @if (
                  materialOrHeading.get('heading').invalid &&
                  (materialOrHeading.get('heading').dirty || materialOrHeading.get('heading').touched || submitted)
                  ) {
                  <div
                    class="invalid-feedback">
                    @if (materialOrHeading.get('heading').errors.invalidCharacters) {
                      <div>
                        {{ "forms.errors.textInput.characters" | translate }}
                      </div>
                    }
                    @if (materialOrHeading.get('heading').errors.maxlength) {
                      <div>
                        {{ "forms.errors.common.maxLength" | translate: { maxLength:
                        materialOrHeading.get("heading").errors.maxlength.requiredLength } }}
                      </div>
                    }
                  </div>
                }
              </div>
              <!--heading-->
              <div class="form-group">
                <label for="{{ 'description-' + i }}">
                  {{ "forms.collection.material.description.label" | translate }}
                </label>
                <textarea
                  class="form-control"
                  id="{{ 'description-' + i }}"
                  formControlName="description"
                  rows="10"
                [ngClass]="{
                  'is-invalid':
                    materialOrHeading.get('description').invalid &&
                    (materialOrHeading.get('description').dirty ||
                      materialOrHeading.get('description').touched ||
                      submitted)
                }"></textarea>
                @if (
                  materialOrHeading.get('description').invalid &&
                  (materialOrHeading.get('description').dirty ||
                  materialOrHeading.get('description').touched ||
                  submitted)
                  ) {
                  <div
                    class="invalid-feedback">
                    @if (materialOrHeading.get('description').errors.invalid) {
                      <div>
                        {{ "forms.errors.description.characters" | translate }}
                      </div>
                    }
                    @if (materialOrHeading.get('description').errors.maxlength) {
                      <div>
                        {{ "forms.errors.common.maxLength" | translate: { maxLength:
                        materialOrHeading.get("description").errors.maxlength.requiredLength } }}
                      </div>
                    }
                  </div>
                }
              </div>
              <!--description-->
            }
            <!--material-->
            <!--heading-->
          </ng-container>
        </fieldset>
      </div>
    }
  </div>
  <div class="row">
    <div class="col">
      <button type="button" class="btn btn-gray" (click)="previous()">{{ "forms.common.previous" | translate }}</button>
    </div>
    <div class="col-auto">
      <button type="reset" class="btn btn-cancel" (click)="emitAbort()">{{ "forms.common.abort" | translate }}</button>
    </div>
    <div class="col-auto">
      <button type="submit" class="btn btn-blue">{{ "forms.common.next" | translate }}</button>
    </div>
  </div>
</form>
}
